import axios from "axios";

// eslint-disable-next-line import/prefer-default-export
export const updateSocialMediaPromise = (personId, socialMediaAttributes) =>
  new Promise((resolve, reject) => {
    axios
      .patch(`/api/v4/person_detail/${personId}/edit_social_details`, {
        person: socialMediaAttributes,
        authenticity_token: ReactOnRails.authenticityToken(),
      })
      .then((res) => {
        resolve({ success: true, data: res.data });
      })
      .catch((err) => {
        reject(err);
      });
  });
